import { useController, useFormContext } from 'react-hook-form';

import { Icon } from '@gitbook/spine-icons';
import { Button, Description, FieldGroup, Label, TextInput } from '@gitbook/spine-react';

import { ExpressionTemplateInput } from '../../../../../Components';

export type McpServerHeadersFieldFormInputs = {
    headers: { key: string; value: string }[];
};

export function McpServerHeadersField(props: { name: 'headers'; disabled: boolean }) {
    const form = useFormContext<McpServerHeadersFieldFormInputs>();
    const { field } = useController({
        name: props.name,
        control: form.control,
    });

    return (
        <FieldGroup orientation="vertical" className="gap-2">
            <Label>HTTP Headers</Label>
            <Description>
                Configure HTTP headers to be sent with the request to the MCP server.
            </Description>
            {field.value.map((h, index) => (
                <div key={index} className="flex items-start gap-2">
                    <TextInput
                        value={h.key}
                        placeholder="Header"
                        onChange={(event) => {
                            const copy = [...field.value];
                            copy[index] = { ...copy[index], key: event.target.value };
                            field.onChange(copy);
                        }}
                        disabled={props.disabled}
                        className="flex-1"
                    />
                    <ExpressionTemplateInput
                        value={h.value}
                        onChange={(value) => {
                            const copy = [...field.value];
                            copy[index] = { ...copy[index], value };
                            field.onChange(copy);
                        }}
                        placeholder="Header value"
                        className="flex-1"
                    />
                    <Button
                        iconOnly
                        kind="blank"
                        leadingIcon={Icon.Trashcan}
                        label="Remove"
                        onPress={() => field.onChange(field.value.filter((_, i) => i !== index))}
                        disabled={props.disabled}
                    />
                </div>
            ))}
            <Button
                kind="secondary"
                leadingIcon={Icon.Plus}
                label="Add header"
                onPress={() => field.onChange([...field.value, { key: '', value: '' }])}
                disabled={props.disabled}
            />
        </FieldGroup>
    );
}
